module.exports = __webpack_public_path__ + "media/loudspeaker.9d4cc7b9.webm";